import React from "react";

const BgContext = React.createContext({});

export default BgContext;